module.exports = __webpack_public_path__ + "assets/Badge-verified.61337496.svg";